import { render, staticRenderFns } from "./Rebuttals.vue?vue&type=template&id=34d2ffe4&scoped=true&"
import script from "./Rebuttals.vue?vue&type=script&lang=js&"
export * from "./Rebuttals.vue?vue&type=script&lang=js&"
import style0 from "./Rebuttals.vue?vue&type=style&index=0&id=34d2ffe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2ffe4",
  null
  
)

export default component.exports